import { GAME_PALETTE } from './53-game-primitives.mjs';

const retired = new Set(['mosaic-paint', 'pattern-stamp', 'cloud-shapes', 'paper-fold']);

const definitions = [
  [
    'sky-rider',
    'Sky Rider',
    'idle',
    'Skim a crystal sea, break the guardians and fly beyond the setting sun.',
    'Drag anywhere to steer, or use arrows / WASD. Your cannon fires automatically. Space or Nova clears enemy fire once per sector. Avoid crystals and red projectiles; aim at each guardian core. Complete eighteen worlds with three shields. P pauses. Private play, no uploaded scores.',
    ['arcade', 'flight', '3d'],
  ],
  [
    'steam-punk-star-killer',
    'Steam Punk Star Killer',
    'idle',
    'Aim the brass cannon. Break the fleet. Turn neutron gravity into a spectacular payday.',
    'Drag to aim and release to launch, or use Left/Right and Space. Break numbered plates, collect fuel and buy upgrades with earned cash. N deploys neutron bombs. Choose Classic, Speed or Timed before starting. Private myAudience device records; separate from the Prometheus game.',
    ['arcade', 'physics', 'steampunk'],
  ],
  [
    'bob-bounce',
    'Bob Bounce',
    'idle',
    'One bouncy Bob. Twenty deliciously daring worlds. Race to the golden arch.',
    'Tap Bob just before he touches down for a powerful bounce; a tap near the top gives a gentle lift. Tap beside him to steer through glowing gates. Gold boosts accelerate immediately for six seconds; blue shields protect one hazard hit or ground stumble. Three unprotected stumbles end the run. Avoid edges and cross the golden finish arch at any speed. Space or Enter bounces; Left and Right bounce sideways. Twenty private courses, unlimited retries.',
    ['arcade', 'platformer', '3d', 'physics'],
  ],
  [
    'ball-sort',
    'Pocket Marbles',
    'idle',
    'Bring each colour home, one satisfying pour at a time.',
    'Tap a glass, then a glowing destination. Matching marbles pour together; each glass holds four. Undo any pour.',
    ['sorting', 'colour'],
  ],
  [
    'sand-layers',
    'Sand Conveyor',
    'idle',
    'Catch sixteen colours as a picture cascades into waiting pots.',
    'Choose a glowing colour for the outlined collector. Six colours stay active together; full pots leave and refill automatically. Empty stations fill first, then the oldest colour is replaced. Clear the picture for a speed bonus.',
    ['sand', 'sorting', 'images'],
  ],
  [
    'mosaic-paint',
    'Tiny Tesserae',
    'idle',
    'Turn an outlined motif into your own ceramic mosaic.',
    'Choose an ink colour and tap the outlined tiles. Fill the motif your way, or choose Free canvas. Undo removes your last brushstroke.',
    ['painting', 'creative'],
  ],
  [
    'pattern-stamp',
    'Stamp Meadow',
    'idle',
    'Make a little print with petals, leaves and ink.',
    'Choose a colour and a stamp. Tap the paper to print; Rotate and Mirror change the next impression. Undo any impression.',
    ['patterns', 'creative'],
  ],
  [
    'ripple-garden',
    'Orchard Rush',
    'idle',
    'Sweep through sunlit fruit and build a juicy combo.',
    'Slice fruit with a continuous sweep, or tap ripe fruit. Catch three or more in one stroke for a combo; avoid the thorn pods. Finish a one-minute private round, then challenge a friend with the same seed.',
    ['slicing', 'arcade'],
  ],
  [
    'pebble-balance',
    'Prism Towers',
    'idle',
    'Carry a luminous tower home, one careful flight at a time.',
    'Move the top disc between three towers. A larger disc cannot sit on a smaller one. Rebuild the complete tower on the right; Undo and progressively taller puzzles keep the challenge growing.',
    ['towers', 'logic'],
  ],
  [
    'thread-loom',
    'Waterworks',
    'idle',
    'Build a flowing route from a mountain spring to thirsty buckets.',
    'Turn the channels before releasing the water. Keep the flow connected, put out fires and power the steam gate to fill the lower collector. Watch the water travel, then refine your route.',
    ['water', 'physics'],
  ],
  [
    'cloud-shapes',
    'Cloud Sketch',
    'idle',
    'Sculpt a cloud against a luminous open sky.',
    'Tap the sky to add soft cloud with your brush. Change brush size or use Erase to shape its edges; Clear starts a fresh sky.',
    ['shapes', 'creative'],
  ],
  [
    'paper-fold',
    'Folded Petals',
    'idle',
    'Unfold a small patch of ink into a symmetrical print.',
    'Choose an ink colour and mark the small paper quarter. Horizontal and Vertical folds mirror your ink in the large unfolded print. Undo restores the last change.',
    ['symmetry', 'creative'],
  ],
  [
    'flow-paths',
    'Brook Ribbon',
    'idle',
    'Guide a shimmering brook through flower-filled valleys.',
    'Trace neighboring ground to extend the brook. Reach the numbered flowers in order, cross wooden aqueducts along their direction and avoid rocks before entering the pool. Complete a valley to unlock a larger route; Back or Undo lets you refine the stream.',
    ['paths', 'drawing'],
  ],
  [
    'gem-swap',
    'Fruit Orchard',
    'score',
    'Swap orchard fruit, watch the harvest tumble, and build a cascade.',
    'Swap neighboring fruit to match three. Four in a line or crossing matches earns a Bloom that blasts nearby fruit. Five in a line earns a Harvest: swap it with any fruit to clear that colour. Swap neighboring powers for a larger blast, a chain of Blooms, or a whole-board Orchard festival. Cascades multiply clear points and consecutive successful swaps earn a capped bonus. More colours arrive at swaps 7 and 14. Finish 20 productive swaps; failed swaps break the streak.',
    ['matching', 'swapping'],
  ],
  [
    'cluster-pop',
    'Bubble Grove',
    'score',
    'Explore a dense 16-by-16 bubble garden and gather a bigger burst.',
    'Tap two or more bubbles of the same colour connected horizontally or vertically on a 16-by-16 board. A group of n earns 10 × n × (n − 1) points, multiplied by its level. Groups of four or more build a capped bonus chain; smaller groups break it. More colours arrive after groups 7 and 14. After each burst, survivors fall within their own column and new bubbles enter from the top; the board never shuffles. Finish 20 groups or when no connected pair remains.',
    ['clusters', 'colour'],
  ],
  [
    'soft-merge',
    'Velvet Tiles',
    'score',
    'Make space on a six-by-six arcade board and grow toward 8192.',
    'Swipe or use direction arrows on a six-by-six board. Equal tiles combine once per slide; consecutive merging slides earn a capped chain bonus. A changed slide without a merge breaks it. Each power-of-two milestone from 32 through 8192 earns its value once. Arcade refills begin at 2/4, grow to 4/8 at 64, 8/16 at 256, 16/32 at 1024 and 64/128 at 4096. Existing tiles stay fixed until your chosen slide. Finish at 8192, when no move remains, or at the 600-action limit. No paid boosts.',
    ['merging', 'sliding'],
  ],
  [
    'block-fit',
    'Patchwork Dock',
    'score',
    'Choose which shape to place and keep room for the next.',
    'Choose a tray shape, rotate if useful, then tap its top-left position. Clear rows or columns for bonuses; consecutive clearing placements build a chain. Clearing the entire board earns 150 points per level. Larger shapes enter after placements 10 and 20. Finish 30 placements or when none fit.',
    ['packing', 'spatial'],
  ],
  [
    'colour-path',
    'Ribbon Run',
    'score',
    'Join matching endpoints without crossing your ribbons.',
    'Start at a labelled endpoint and tap neighboring squares toward its matching partner. Join all pairs without crossing and fill every square. Retrace or restart an unfinished ribbon. Solve three puzzles: three pairs first, then four. Each later puzzle carries a larger completion bonus.',
    ['tracing', 'paths'],
  ],
  [
    'memory-pairs',
    'Hidden Friends',
    'score',
    'Meet the hidden pairs, then remember where they belong.',
    'Turn over two cards. Matching pairs stay revealed; a missed pair closes after a short pause. Consecutive matches earn a bonus, and three boards complete the round.',
    ['memory', 'pairs'],
  ],
  [
    'tile-slide',
    'Pocket Parade',
    'score',
    'Slide a scattered little picture back into order.',
    'Tap a tile beside the empty space. Put numbers 1–8 in order with the space last. Early puzzles use a short scramble; later puzzles give you a richer challenge.',
    ['ordering', 'sliding'],
  ],
  [
    'rotation-loop',
    'Loop Lantern',
    'score',
    'Turn the lantern paths until every connection lights.',
    'Tap pipes clockwise. Connect source to destination through every tile without leaks. Three networks use progressively deeper 6, 12 and 18-turn scrambles, with larger level rewards and bonuses for avoiding extra rotations. Alternative complete networks also count.',
    ['rotation', 'connections'],
  ],
  [
    'number-trail',
    'Firefly Trail',
    'score',
    'Find each glowing number and finish the trail.',
    'Tap numbers in order. Every new correct number earns points; a clean chain adds a capped bonus. Wrong taps break the chain without losing progress or earning points. Finish trails of 9, 12 and 16 numbers for increasingly larger completion bonuses.',
    ['sequence', 'search'],
  ],
  [
    'spot-pair',
    'Twin Trinkets',
    'score',
    'Find the two little objects that belong together.',
    'Choose the two trinkets with the same silhouette and colour. Accurate consecutive pairs earn a bonus; each stage adds variety and ten pairs finish the round.',
    ['observation', 'matching'],
  ],
];

/** Closed original game identities and concise rules. Abstract genre mechanics are
 * familiar; levels, illustrations and rewards are independently authored. Points
 * represent meaningful transitions, never purchases, paid retries or invitation gates. */
export const GAME_CATALOG = Object.freeze(
  definitions.map(([id, title, kind, description, instructions, tags]) =>
    Object.freeze({
      id,
      companionOnly: ['bob-bounce', 'steam-punk-star-killer', 'sky-rider'].includes(id),
      available: !retired.has(id),
      title,
      kind,
      description,
      instructions,
      tags: Object.freeze(['games', kind, ...tags]),
      palette: GAME_PALETTE,
    }),
  ),
);
/** Active discovery excludes retired toys while historical identities remain
 * available to isolated replay fixtures. Availability is enforced at delivery. */
export const ACTIVE_GAME_CATALOG = Object.freeze(GAME_CATALOG.filter((game) => game.available));
/** Project discoverable games from already-authorized feature flags. This list
 * grants no mutation or score permission; boundaries reauthorize every action. */
export function availableGames(features) {
  return ACTIVE_GAME_CATALOG.filter(
    (game) => features?.games === true && features[`game-${game.id}`] === true,
  );
}
/** Return a maintained identity; unknown identities have no executable rules. */
export function getGame(id) {
  return GAME_CATALOG.find((game) => game.id === id);
}
